export const ORIGIN_LINK = {
  spero: {
    test: 'https://dev-h5.secon.cn/',
    preview: 'https://spero-h5.secon.cn/pre/',
    production: 'https://spero-h5.secon.cn/'
  },
  h5hd: {
    test: 'https://test-h5-hd.secon.cn/',
    preview: 'https://h5-hd.secon.cn/pre/',
    production: 'https://h5-hd.secon.cn/prod/'
  }
}
